import React from 'react';
import styled from 'styled-components';
import { TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const NodataWrapper = styled.div`
  height: ${(props) => (props?.small ? '100%' : 'calc(100% - 80px)')};
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DeletedView = (props) => {
  const { small = false } = props;
  return (
    <NodataWrapper className="jctr actr" small={small}>
      <SVGIcon name="DeletedView" size="xxxl" />
      <TextStyle weight="Medium">
        <FormattedMessage id="app.widget.deletedView" />
      </TextStyle>
    </NodataWrapper>
  );
};

export default DeletedView;
